/**
 * @desc 删除
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.baseCountry.deleteOne.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCountry/delete`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
